import { Box } from 'styled-system/jsx';
import { css } from 'styled-system/css';
import { InputAttachmentType } from '@/common/components/base/input/base/CommonInput.type.ts';
import createAttachment from '@/common/components/base/input/base/helpers/createAttachment.ts';

const MobileAttachmentElement = () => (
  <Box width="75%" borderRight="2px solid {colors.gray-1}">
    <p
      className={css({
        textStyle: 'b1',
        color: 'black-4',
        textAlign: 'center',
      })}
    >
      +98
    </p>
  </Box>
);
const mobileLabelAttachment: InputAttachmentType = createAttachment({
  element: <MobileAttachmentElement />,
});

export default mobileLabelAttachment;
